import { BrowserStorageDataStore } from './browser-storage-data-store';

/**
 * Defines a single value data store using browser session storage as the underlying storage mechanism
 * This data store uses the provided storage key to get/set/clear a value from SessionStorage.
 */
export abstract class SessionDataStore<T> extends BrowserStorageDataStore<T> {
    constructor(storageKey: string) {
        super(storageKey, MsftSme.SessionStorageHandler.getSessionStorage());
    }
}
